// == Import npm
import React, { useEffect } from "react";
import { Button, Form, Input } from "antd";

// == Import SCSS
import "../modalUpdate.less";

// == Import icons

// == import i18n
import { useTranslation } from "react-i18next";

const FormUpdate = ({
  user,
  onNext,
  onPrevious,
  visitorCheck,

  current,
}) => {
  const [t] = useTranslation();

  const [form] = Form.useForm();

  //const currentVisitors = useSelector(state => state.usersWS.current);

  const handleUpdate = values => {
    /*    dispatch(update({ ...values, login: values.email, id: user.id })).then(updatedUser => {
      dispatch(list(currentAcm, true));
      if (typeVisitor === "resident") {
        if (currentVisitors.visits) {
          dispatch(updateVisitsFromUser(currentAcm, currentVisitors.user));
          message.success("Vos modifications ont bien été enregistrées", 10);
          if (current + 1 === visitorCheck.length) {
            setVisible(false);
            setVisitorCheck([]);
            setCurrent(0);
          }
        }
      } else if (typeVisitor === "visitor") {
        if (currentVisitors.visits) {
          dispatch(updateVisitsFromUser(currentAcm, currentVisitors.user, user));
          message.success("Vos modifications ont bien été enregistrées", 10);
          if (current + 1 === visitorCheck.length) {
            setVisitorCheck([]);
            setVisible(false);
          }
        }
      }

      return updatedUser;
    });*/
    onNext();
  };

  useEffect(() => {
    form.setFieldsValue({
      firstname: user.firstname || "",
      lastname: user.lastname || "",
      company: user.company || "",
      phone: user.phone || "",
      mail: user.email || "",
    });
  }, [user, form]);

  /* eslint-disable no-template-curly-in-string */
  const validateMessages = {
    required: "${label} est obligatoire",
  };
  /* eslint-enable no-template-curly-in-string */

  return (
    <Form
      name="nest-messages"
      validateMessages={validateMessages}
      onFinish={handleUpdate}
      initialValues={user}
      form={form}
    >
      <Form.Item name="firstname" label={t("FirstName")} rules={[{ required: true }]}>
        <Input
          onBlur={() => {
            // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
            window.scrollTo(0, 0);
          }}
        />
      </Form.Item>

      <Form.Item name="lastname" label={t("LastName")} rules={[{ required: true }]}>
        <Input
          onBlur={() => {
            // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
            window.scrollTo(0, 0);
          }}
        />
      </Form.Item>

      <Form.Item name="phone" label={t("Phone")}>
        <Input
          onBlur={() => {
            // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
            window.scrollTo(0, 0);
          }}
        />
      </Form.Item>

      <Form.Item name="company" label={t("Company")}>
        <Input
          onBlur={() => {
            // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
            window.scrollTo(0, 0);
          }}
        />
      </Form.Item>

      <Form.Item className="mail" name="mail" label={t("Email")}>
        <Input
          disabled
          onBlur={() => {
            // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
            window.scrollTo(0, 0);
          }}
        />
      </Form.Item>

      <div
        style={{
          marginTop: "50px",
          alignItems: "center",
          display: "flex",
          flexFlow: "column wrap",
        }}
      >
        {onNext && (
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            style={{ marginBottom: "16px", width: "300px" }}
            onBlur={() => {
              // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
              window.scrollTo(0, 0);
            }}
          >
            {visitorCheck.length === current + 1 ? t("Finish") : t("Next")}
          </Button>
        )}
        {onPrevious && (
          <Button
            type="default"
            size="large"
            onClick={onPrevious}
            style={{ width: "300px" }}
            onBlur={() => {
              // Because on mobile, Ant-d has a problem with onscreen keyboard and webview which puh the screen when the keyboard is deployed
              window.scrollTo(0, 0);
            }}
          >
            {t("Previous")}
          </Button>
        )}
      </div>
    </Form>
  );
};

export default FormUpdate;
